
export default {
  formActions: {
    'addPlaceInput': 'Hely megadása',
    'clearRoute': 'Útvonal törlése',
    'reverseRoute': 'Útvonal megfordítása',
    'roundTrip': 'Körutazás',
    'toggleRoundTrip': 'Körutazás be-/kikapcsolása',
    'showDangerousAreas': 'Veszélyes Területek'
  }
}
